import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/Jay_Renters/subs.vtt';
import poster from '@/static/assets/reviews/Jay_Renters/video.jpg';

export const Jay: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Renters, ReviewProduct.All],
  reviewerName: 'Jay',
  videoUrl: `${ASSETS_URL}/renters/Jay_Renters.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
